import { apiSlice } from './apiSlice';
const STOREDEPOSITS_URL = '/api/storeDeposits';


export const storeDepositsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStoreDeposits: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: STOREDEPOSITS_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['StoreDeposits'],
    }),
    getStoreDepositDetails: builder.query({
      query: (storeDepositId) => ({
        url: `${STOREDEPOSITS_URL}/${storeDepositId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    createStoreDeposit: builder.mutation({
      query: (storeDepositData) => ({
        url: STOREDEPOSITS_URL,
        method: 'POST',
        body: storeDepositData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['StoreDeposits'],
    }),
    updateStoreDeposit: builder.mutation({
      query: ({ storeDepositId, ...data }) => ({
        url: `${STOREDEPOSITS_URL}/${storeDepositId}`,
        method: 'PUT',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['StoreDeposits'],
    }),
    uploadStoreDepositImages: builder.mutation({
      query: (formData) => ({
        url: '/api/upload',
        method: 'POST',
        body: formData,
      }),
    }),
    deleteStoreDeposit: builder.mutation({
      query: (storeDepositId) => ({
        url: `${STOREDEPOSITS_URL}/${storeDepositId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['StoreDeposits'],
    }),
    createReview: builder.mutation({
      query: ({ storeDepositId, ...data }) => ({
        url: `${STOREDEPOSITS_URL}/${storeDepositId}/reviews`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['StoreDeposits'],
    }),
    getTopStoreDeposits: builder.query({
      query: () => `${STOREDEPOSITS_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGetStoreDepositsQuery,
  useGetStoreDepositDetailsQuery,
  useCreateStoreDepositMutation,
  useUpdateStoreDepositMutation,
  useUploadStoreDepositImagesMutation,
  useDeleteStoreDepositMutation,
  useCreateReviewMutation,
  useGetTopStoreDepositsQuery,
} = storeDepositsApiSlice;